(() => {
  if (window.__cartSuccessToastInit) return;
  window.__cartSuccessToastInit = true;

  const DISPLAY_MS = 3000;
  let hideTimeout = null;

  function getToast() {
    return document.getElementById('CartSuccessToast');
  }

  function show() {
    const toast = getToast();
    if (!toast) return;
    clearTimeout(hideTimeout);
    toast.removeAttribute('hidden');
    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });
    hideTimeout = setTimeout(hide, DISPLAY_MS);
  }

  function hide() {
    const toast = getToast();
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(() => toast.setAttribute('hidden', ''), 320);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'product-form') {
        show();
      }
    });
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.cart-success-toast__close')) {
      hide();
    }
  });
})();
